import {getAPIGatewayPostRequest} from "../util/Util";
import {
    ENDPOINT_GET_MHE_VALIDATION,
    ENDPOINT_GET_PRESIGNED_URL_MHE_VALIDATION,
    ENDPOINT_TRIGGER_MHE_VALIDATION
} from "../util/Constants";
import {getAPIGatewayDataFromParent} from "../handler/ParentDataHandler";

/**
 * Fetches Validation execution data for a device
 *
 * @returns {Promise<*>}
 * @param macAddress
 */
export async function getMHEValidations(macAddress) {
    const requestBody = {
        macAddress: macAddress
    };
    const args = getAPIGatewayPostRequest(requestBody, ENDPOINT_GET_MHE_VALIDATION);
    return await getAPIGatewayDataFromParent(args);
}


/**
 * Triggers an instance of MHE Validation
 *
 * @returns {Promise<*>}
 * @param triggerData
 */
export async function triggerMHEValidations(triggerData) {
    const requestBody = triggerData;
    const args = getAPIGatewayPostRequest(requestBody, ENDPOINT_TRIGGER_MHE_VALIDATION);
    return await getAPIGatewayDataFromParent(args);
}

/**
 * Fetches S3Presigned Url for MHE Validation report
 *
 * @returns {Promise<*>}
 * @param objectKey
 */
export async function getPresignedURLcall(objectKey) {
    const requestBody = {
        objectKey: objectKey
    };
    const args = getAPIGatewayPostRequest(requestBody, ENDPOINT_GET_PRESIGNED_URL_MHE_VALIDATION);
    return await getAPIGatewayDataFromParent(args);
}



// WEBPACK FOOTER //
// ./src/components/resources/MHEValidationResource.js